import { useAuthenticator } from "@aws-amplify/ui-react";
import { Crisp } from "crisp-sdk-web";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "store/store";
import type { TPortalType } from "store/types";

import { useIsMobile } from "./useIsMobile";

// https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/npm/

const useCrisp = (portalType: TPortalType) => {
    const { isMobile } = useIsMobile();
    const { user } = useAuthenticator((context) => [context.user]);
    const { crispHash } = useSelector((state: RootState) => state.settings);
    const { crispHash: crispHashBeneficiarPortal } = useSelector((state: RootState) => state.beneficiary);

    useEffect(() => {
        if (!user.attributes?.email || isMobile) {
            return;
        }

        if (crispHash) {
            ["book", "urssaf"].includes(portalType)
                ? Crisp.configure("6a9a2cd4-4735-4500-ad76-0bc81e596c87")
                : Crisp.configure("f93e1224-9334-4bea-a6c8-a6688d507632");
            Crisp.setTokenId(crispHash);
        } else if (crispHashBeneficiarPortal && portalType === "beneficiary") {
            Crisp.configure("2434356e-dcfd-4050-b77f-e92afc0f65e2");
            Crisp.setTokenId(crispHashBeneficiarPortal);
        }

        Crisp.user.setEmail(user.attributes.email);
        Crisp.user.setNickname(user.attributes.name ?? user.attributes.email);

        Crisp.chat.onChatOpened(() => {
            // Set helpdesk as first tab
            Crisp.chat.setHelpdeskView();

            // On opening chat, trigger default scenario ("Degré de la demande")
            Crisp.session.pushEvent("open-chatbox");
        });
    }, [user.attributes, crispHash, crispHashBeneficiarPortal, portalType, isMobile]);
};

export default useCrisp;
